import gql from "graphql-tag";
import { Location } from "../baseTypes";
 export default gql`
  query ListAllLocations {
    listLocations (limit:500){
      items {
        companyId
        id
        locationId
        healthDeparmentNumber
        name
      }
    }
  }
`;
export interface ListAllLocationsQuery {
  listLocations: {
    items: Array<Location> | null;
  };
}
